import React, { useEffect } from "react";
import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import { globalFontStyle, globalStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import FastImage from "../../../common/FastImage";
import { currencyConverter } from "../../../utils/commonMethods";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import {globalConfigurableData, GlobalScreens} from "../../../utils/globalConstant";
import { Image } from 'expo-image';
import { Dimensions } from 'react-native';
import {defaulteventimage} from '../../../utils/images';
import { getSubcategoryImage } from '../../../utils/subcategoryImages';

const PortfolioClosedCard = ({ item }) => {
  const screenWidth = Dimensions.get('window').width;
  
  const getImageSize = () => {
    if (screenWidth < 768) {
      return 45;
    } else if (screenWidth < 1024) {
      return 45; 
    } else {
      return 45;
    }
  };

  const imageSize = getImageSize();

  const randomImages = [
    'https://cdn.britannica.com/64/171264-050-C7253301.jpg',
    'https://cdn.britannica.com/35/238335-050-2CB2EB8A/Lionel-Messi-Argentina-Netherlands-World-Cup-Qatar-2022.jpg',
    'https://cdn.britannica.com/56/199056-050-CCC44482/Jeff-Bezos-2017.jpg', 
    'https://cdn.britannica.com/99/236599-050-1831D9C0/President-Joe-Biden-2023.jpg',
    'https://cdn.britannica.com/42/193142-050-F69B1A23/Mark-Zuckerberg-2010.jpg'
  ];

  const getImage = () => {
    return item?.imageurl || getSubcategoryImage(item?.subcategory) || defaulteventimage();
  };

  return (
    <View>
      <View style={[globalStyle.cardContainer,
        { paddingHorizontal: 0,
          borderColor: GlobalScreens.Portfolio.borderColor,
          backgroundColor: globalConfigurableData.cardBgColor, }]}>
        <View style={{
          paddingHorizontal: 15,
          paddingBottom: 15,
          borderBottomColor: GlobalScreens.Portfolio.borderColor,
          borderBottomWidth: 0.75 }}>
          <View style={styles.upperRow}>
            <Image
              style={[styles.cardImg, {
                width: imageSize,
                height: imageSize,
                objectFit: 'cover'
              }]}
              source={getImage()}
              contentFit="cover"
              transition={1000}
            />
            <View style={{
              flex: 1,
              marginLeft: 16,
              justifyContent: !item?.subtitle ? 'center' : 'flex-start',
              minHeight: imageSize
            }}>
              <Text
                style={[
                  globalFontStyle.appFontHeading,
                  {color: globalConfigurableData.primaryTextColor1}
                ]}
                numberOfLines={2}>
                {item?.title}
              </Text>
              <View style={{flexDirection: 'row', alignItems: 'center', marginTop: 4}}>
                <FormTextLabel
                  labelStyles={[
                    globalFontStyle.appFontBody,
                    {color: globalConfigurableData.secondaryTextColor1}
                  ]}
                  label="Outcome: "
                />
                <FormTextLabel
                  labelStyles={[
                    globalFontStyle.appFontSubHeading,
                    {
                      color: item?.correctvalue === "Y" 
                        ? GlobalScreens.Event.yesBtnTxt 
                        : GlobalScreens.Event.noBtnTxt,
                    },
                  ]}
                  label={item?.correctvalue === "Y" ? "Yes" : "No"}
                />
              </View>
            </View>
          </View>
        </View>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: 15,

            paddingHorizontal: 20,
          }}
        >
          <View style={[styles.rowCol, { alignItems: "flex-start" }]}>
            <FormTextLabel 
              labelStyles={[
                globalFontStyle.appFontSubText,
                {
                  fontSize: 10,
                  fontWeight: '300',
                  color: globalConfigurableData.secondaryTextColor1,
                  opacity: 0.6
                },
                styles.marginRow
              ]} 
              label={"INVESTMENT"} 
            />
            <Text style={[styles.rowVal]}>
              {item?.totalinvested
                ? currencyConverter(item?.totalinvested)
                : "0"}
            </Text>
          </View>
          <View style={[styles.rowCol, { alignItems: "flex-start" }]}>
            <FormTextLabel 
              labelStyles={[
                globalFontStyle.appFontSubText,
                {
                  fontSize: 10,
                  fontWeight: '300',
                  color: globalConfigurableData.secondaryTextColor1,
                  opacity: 0.6
                },
                styles.marginRow
              ]} 
              label={"PAYOUT"} 
            />
            <Text style={[styles.rowVal]}>
              {item?.totalreturn ? currencyConverter(item?.totalreturn) : "0"}
            </Text>
          </View>

          <View style={[styles.rowCol, { alignItems: "flex-start" }]}>
            <FormTextLabel 
              labelStyles={[
                globalFontStyle.appFontSubText,
                {
                  fontSize: 10,
                  fontWeight: '300',
                  color: globalConfigurableData.secondaryTextColor1,
                  opacity: 0.6
                },
                styles.marginRow
              ]} 
              label={"REFUNDS"} 
            />
            <Text style={[styles.rowVal]}>
              {item?.totalrefund ? currencyConverter(item?.totalrefund) : "0"}
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
};

export default PortfolioClosedCard;

const styles = StyleSheet.create({
  rowHeader: {
    ...globalFontStyle.appFontSmallText,
    color: globalConfigurableData.quaternaryTextColor1,
  },
  rowVal: {
    ...globalFontStyle.appFontBody,
    color: globalConfigurableData.primaryTextColor1,
  },
  cardImg: {
    borderRadius: 8,
    overflow: 'hidden',
  },
  upperRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  priceBlock: {
    flexDirection: "row",
    backgroundColor: Colors.grey3,
    paddingVertical: 11,
    paddingHorizontal: 22,
    borderRadius: 100,
    justifyContent: "space-between",
    borderWidth: 0.2,
    marginTop: 20,
    marginBottom: 28,
  },
  rowCol: {
    flex: 1,
    flexBasis: 0,
    flexShrink: 0,
    alignItems: "center",
  },
  sellTxt: {
    borderWidth: 1,
    paddingHorizontal: 30,
    paddingVertical: 5,
    borderRadius: 100,
    backgroundColor: "rgba(231, 93, 22, 0.1)",
    borderColor: "#E75D16",
  },
  marginRow: {
    marginBottom: 5,
    color: globalConfigurableData.primaryTextColor1,
  },
});
